const STORAGE_KEY = "refCode"
const REF_PREFIX = "ref_"

function extractRefCode(): string | null {
  // Telegram: startapp param → initDataUnsafe.start_param
  const startParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param
  if (startParam?.startsWith(REF_PREFIX)) {
    return startParam.slice(REF_PREFIX.length)
  }

  // Web: URL query param ?ref_CODE
  const match = window?.location?.search?.match(/[?&]ref_([a-zA-Z0-9]+)/)
  if (match) {
    return match[1]
  }

  return null
}

export function captureRefCode(): void {
  const code = extractRefCode()
  if (code) {
    sessionStorage.setItem(STORAGE_KEY, code)
  }
}

export function getRefCode(): string | null {
  return sessionStorage.getItem(STORAGE_KEY)
}

export function clearRefCode(): void {
  sessionStorage.removeItem(STORAGE_KEY)
}
